import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import { type Donation, Donations } from '../Donations/Donations'
import styles from './TextBlock.module.css'

export type TextAreaProps = {
  title?: string
  heading?: string
  paragraph?: React.ReactNode
  feature?: boolean
  layout?: 'default' | 'compact' | 'fullwidth'
  donations?: Donation[]
  donationstitle?: string
  donationsdescription?: React.ReactNode
  donationsterms?: string
  donationsasset?: React.ReactNode
  featureVariant?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary'
} & StylePanelProps

export const PhnxTextBlock: React.FC<TextAreaProps> = ({
  title,
  heading,
  paragraph,
  layout = 'default',
  padding,
  backgroundColor,
  textColor,
  alignment = 'left',
  donations,
  donationstitle,
  donationsdescription,
  donationsterms,
  donationsasset,
  feature = false,
  featureVariant = 'primary',
}) => {
  const paddingStyles = useResponsivePadding(padding)
  const style = {
    backgroundColor,
    color: textColor,
    ...paddingStyles,
  }

  return (
    <div style={style} className={`stylepanel ${styles[`variant-${featureVariant}`]}`}>
      <div
        className={`${feature ? 'feature' : 'container'} ${styles[`layout-${layout}`]} ${styles[`alignment-${alignment}`]} ${styles[`background-${feature ? 'feature' : ''}`]}`}
      >
        <div className="title-container-group">
          {title && <div className={`${styles.title} ${feature ? '' : 'title'}`}>{title}</div>}
          {heading && (
            <div className={styles.heading}>
              <h2 className="subtitle">{heading}</h2>
            </div>
          )}
        </div>
        {paragraph && <div>{paragraph}</div>}
        {feature && donations && (
          <Donations
            donations={donations}
            title={donationstitle}
            description={donationsdescription}
            terms={donationsterms}
            asset={donationsasset}
            variant={featureVariant}
          />
        )}
      </div>
    </div>
  )
}

export default PhnxTextBlock
